import { SelectField, SelectFieldProps } from "matsuri-ui"
import { css } from "@emotion/react"
import { requestSearchListingByName } from "../hooks/useListings"
import { useAuth } from "../hooks/useAuth"

export const ListingSelectField = (
    props: Omit<SelectFieldProps, "loadOptions">
) => {
    const { token } = useAuth()

    return (
        <SelectField
            loadOptions={async ({ query, selectedOptions }) => {
                if (query === "") {
                    return selectedOptions
                }

                const { data } = await requestSearchListingByName(
                    token,
                    query,
                    { page: 1, pageSize: 20 }
                )
                return data?.data?.map(listing => ({
                    label: listing.listing.name,
                    value: listing.listing.id,
                    address: listing.listing.address
                }))
            }}
            renderOption={option => (
                <div>
                    <div>{option.label}</div>
                    {option.address && (
                        <div
                            css={css`
                                margin-top: 2px;
                                font-size: 0.8rem;
                                color: #666;
                            `}
                        >
                            {option.address}
                        </div>
                    )}
                </div>
            )}
            {...props}
        />
    )
}
